import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { FilterService } from '../../services/filter.service';
import { PlaceholderChildComponent } from '../../../layout/classes/placeholder-child-component.abstract';
import { FilterPanelService } from '../../services/filter-panel.service';

@Component({
  selector: 'gen-filter-panel-wrapper',
  templateUrl: './filter-panel-wrapper.component.html',
  styleUrls: [ './filter-panel-wrapper.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterPanelWrapperComponent extends PlaceholderChildComponent implements OnInit, AfterViewInit {
  @Input() type: string;
  @Input() subtype: string;
  @Input() resourceTitle: string;
  @Input() clearFilterTranslateKey: string;
  @Input() enableStatistics: boolean;
  @Input() context: any;
  @Input() isFullScreen: boolean = true;
  @Input() filterAdminMode: boolean = false; //In this mode filter panel is always shown (not poping out) and more...
  @Output() updatePanelState: EventEmitter<any> = new EventEmitter<any>();
  public panelName = FilterService.FilterPanelName;
  public isFilterPanelOpened: boolean = false;

  constructor(private filterPanel: FilterPanelService) {
    super();
  }

  beforeClose() {
  }

  ngOnInit() {

    if (! this.resourceTitle) this.resourceTitle = 'Filter';
  }

  ngAfterViewInit() {
    if (this.filterAdminMode && !this.isFilterPanelOpened) {
      this.toggleFilterPanel();
      this.isFilterPanelOpened = true;
    }
  }

  public toggleDisplayStatusChanged(event: boolean) {
    this.isFilterPanelOpened = event;
    this.updatePanelState.emit(this.isFilterPanelOpened);
  }

  public toggleFilterPanel() {
    this.filterPanel.togglePanel(true,
        {
          type: this.type,
          subType: this.subtype,
          enableStatistics: this.enableStatistics,
          context: this.context,
          applyBtnText: 'Apply',
          saveBtnText: 'Save ' + this.resourceTitle,
          clearFilterTranslateKey: this.clearFilterTranslateKey,
          resourceTitle: this.resourceTitle,
          filterAdminMode: this.filterAdminMode
        });
  }
}
